import React, { useEffect } from 'react'

// HOC which saves current rendered component
// main purpose is because of smart transition between pages
// this prevents re-rendering on same page components
export const WithRenderedComponent =
  (WrappedComponent, render, setRenderedComponentName, id) =>
  ({ ...props }) => {
    let displayName = id || 'not-defined'
    if (WrappedComponent) {
      displayName = `${getDisplayName(WrappedComponent)}`
      WrappedComponent.displayName = displayName
    }

    // for tests
    if (!setRenderedComponentName) {
      return <WrappedComponent {...props} />
    }

    useEffect(() => {
      if (displayName) {
        setRenderedComponentName(displayName)
      }
    }, [displayName])

    if (render) {
      return render(props)
    }

    return <WrappedComponent {...props} />
  }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}
